import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ReviewPackageWorkspaceMergeProgressDialogComponent } from './review-package-workspace-merge-progress-dialog.component';

@NgModule({
  declarations: [
    ReviewPackageWorkspaceMergeProgressDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatExpansionModule,
  ],
  exports: [
    ReviewPackageWorkspaceMergeProgressDialogComponent
  ]
})
export class ReviewPackageWorkspaceMergeProgressDialogModule { }
